import { useRef } from "react";
import { showErrorAlert } from "../../../helpers/alert";


type Props = {
    onAddFile: (file: File) => void;
}

export const CommunityAttachment = ({ onAddFile }: Props) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const acceptedFormats = [
        '.jpg', '.jpeg', '.png', '.gif', '.webp',
        '.mp4', '.webm', '.mov', '.avi',
        '.mp3', '.wav', '.ogg', '.m4a',
        '.pdf', '.xls', '.xlsx', '.csv', '.doc', '.docx', '.ppt', '.pptx', '.txt'
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if(!file)
            return;

        // Validate size (max 10MB)
        if (file.size > 10 * 1024 * 1024) {
            showErrorAlert({
                title: 'File too large',
                message: 'El archivo debe ser menor a 15MB'
            });
            return;
        }

        const extension = `.${file.name.split('.').pop()?.toLowerCase()}`;

        if (!acceptedFormats.includes(extension)) {
            return;
        }

        onAddFile(file);
    };


    return (
        <div>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleChange}
                accept={acceptedFormats.join(',')}
                style={{ display: "none" }}
            />
            <button className="attachment" onClick={() => fileInputRef.current?.click()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12.1999 11.7983L10.7899 13.2083C10.0099 13.9883 10.0099 15.2583 10.7899 16.0383C11.5699 16.8183 12.8399 16.8183 13.6199 16.0383L15.8399 13.8183C17.3999 12.2583 17.3999 9.72828 15.8399 8.15828C14.2799 6.59828 11.7499 6.59828 10.1799 8.15828L7.75988 10.5783C6.41988 11.9183 6.41988 14.0883 7.75988 15.4283" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    )
}